(function () {
  function nudge(el) {
    el.dispatchEvent(new Event("change", { bubbles: true }));
    el.dispatchEvent(new Event("input", { bubbles: true }));
  }

  function initBridge(bridge) {
    const form = bridge.closest('form[action*="/cart/add"]');
    if (!form) return;

    const productId = bridge.getAttribute("data-product-id");
    if (!productId) return;

    const uiRoot = document.querySelector(`.amg--iron-picker[data-product-id="${productId}"]`);
    if (!uiRoot) return;

    let checkboxes = Array.from(uiRoot.querySelectorAll(".amg--iron-checkbox"));
    if (!checkboxes.length) return;

    // Leading underscore hides this from customer-facing UI (cart, order confirmation)
    // but remains visible in Shopify admin on the order
    let propInput =
      bridge.querySelector('input[name="properties[_Selected irons]"]') ||
      form.querySelector('input[name="properties[_Selected irons]"]');

    if (!propInput) {
      propInput = document.createElement("input");
      propInput.type = "hidden";
      propInput.name = "properties[_Selected irons]";
      bridge.appendChild(propInput);
    }

    function ensureQtyInputs() {
      let inputs = Array.from(form.querySelectorAll('input[name="quantity"]'));
      if (inputs.length === 0) {
        const shim = document.createElement("input");
        shim.type = "number";
        shim.name = "quantity";
        shim.min = 1;
        shim.step = 1;
        shim.value = 1;
        shim.className = "amg--qty-shim";
        form.appendChild(shim);
        inputs = [shim];
      }
      return inputs;
    }

    let qtyInputs = ensureQtyInputs();

    const countEl = uiRoot.querySelector(".amg--iron-count");
    const summaryEl = uiRoot.querySelector(".amg--iron-picker__summary");

    function updateFromSelection() {
      checkboxes = Array.from(uiRoot.querySelectorAll(".amg--iron-checkbox"));

      const picked = checkboxes.filter(cb => cb.checked).map(cb => cb.value);
      const count = picked.length || 1;

      propInput.value = picked.join(", ");

      qtyInputs = ensureQtyInputs();
      qtyInputs.forEach(q => { q.value = count; nudge(q); });

      if (countEl) countEl.textContent = String(picked.length);
      if (summaryEl) {
        const word = picked.length === 1 ? "club" : "clubs";
        summaryEl.innerHTML = `<span class="amg--iron-count">${picked.length}</span> ${word} selected`;
      }
    }

    checkboxes.forEach(cb => cb.addEventListener("change", updateFromSelection));
    setTimeout(updateFromSelection, 200);

    const mo = new MutationObserver(() => {
      const newBoxes = Array.from(uiRoot.querySelectorAll(".amg--iron-checkbox"));
      if (newBoxes.length && newBoxes.length !== checkboxes.length) {
        checkboxes.forEach(cb => cb.removeEventListener("change", updateFromSelection));
        newBoxes.forEach(cb => cb.addEventListener("change", updateFromSelection));
        checkboxes = newBoxes;
        updateFromSelection();
      }
    });
    mo.observe(uiRoot, { childList: true, subtree: true });

    form.addEventListener("submit", updateFromSelection, true);
    form.querySelectorAll("button[name='add'], .mw-apo-add-to-cart-cloned").forEach(btn => {
      btn.addEventListener("click", () => setTimeout(updateFromSelection, 0), true);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    // Clear any legacy cart note from previous implementation
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ note: "" }),
    }).catch(() => {});

    document.querySelectorAll(".amg--iron-bridge[data-product-id]").forEach(initBridge);
  });
})();